module.exports = __webpack_public_path__ + "img/a11y-onionskin_cn.20a630f.jpg";